import React, { useState } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import ElectricityApartmentAgreementsService, {
  ApartmentAgreement,
} from "services/electricity/electricity-apartment-agreements.service";

interface Props {
  apartment: ApartmentAgreement;
  onSaved: () => void;
  onCancel: () => void;
}

export default function RenameApartmentForm({ apartment, onSaved, onCancel }: Props) {
  const [name, setName] = useState(apartment.name);
  const [saving, setSaving] = useState(false);
  const [validated, setValidated] = useState(false);

  const isValid = name.trim().length > 0 && name.trim() !== apartment.name;

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setValidated(true);
    if (!isValid) {
      toast.error("Korteri uus nimi peab erinema senisest");
      return;
    }
    setSaving(true);
    try {
      await ElectricityApartmentAgreementsService.rename(apartment.id, { name: name.trim() });
      toast.success("Korter ümber nimetatud");
      onSaved();
    } catch {
      toast.error("Korteri ümbernimetamine ebaõnnestus");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Form onSubmit={submit} className="border rounded p-3 mb-3 bg-light" noValidate validated={validated}>
      <h5>Nimeta korter ümber</h5>

      <div className="row">
        <div className="col-12 col-md-6">
          <Form.Label className="mb-0 align-self-start m-1 text-center">
            <span className="text-nowrap">Korteri nr*</span>
          </Form.Label>
          <Form.Control
            required
            type="text"
            value={name}
            maxLength={64}
            onChange={(e) => setName(e.target.value)}
          />
          <Form.Control.Feedback className="text-right" type="invalid">Kohustuslik väli</Form.Control.Feedback>
        </div>
      </div>

      <div className="d-flex mt-4">
        <Button type="submit" variant="primary" disabled={saving || !isValid} className="mr-2">
          {saving ? <Spinner size="sm" animation="border" /> : "Salvesta"}
        </Button>
        <Button type="button" variant="secondary" onClick={onCancel} disabled={saving}>
          Tühista
        </Button>
      </div>
    </Form>
  );
}
